import gql from 'graphql-tag';

import remoteItemFromProviderFragment from './remoteItemFromProviderFragment';

export const oneDriveRemoteItemsPageFragment = gql`
  fragment oneDriveRemoteItemsPageFragment on OneDriveRemoteItemsPage {
    dokkioClass
    nextToken
    remoteItems {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
export default oneDriveRemoteItemsPageFragment;
